/**
 * LoadingSpinner - 한국찬송가공회 디자인 시스템
 *
 * Suspense fallback 및 일반 로딩 상태에 사용되는 스피너 컴포넌트
 */

interface LoadingSpinnerProps {
  /** 로딩 메시지 (선택사항) */
  message?: string;
  /** 전체 화면 모드 여부 */
  fullScreen?: boolean;
  /** 크기 (px) */
  size?: number;
}

export default function LoadingSpinner({
  message = '로딩 중...',
  fullScreen = true,
  size = 48,
}: LoadingSpinnerProps) {
  const containerClass = fullScreen
    ? 'min-h-screen bg-gray-50 flex items-center justify-center'
    : 'flex items-center justify-center p-8';

  return (
    <div className={containerClass}>
      <div className="text-center">
        {/* 스피너 */}
        <div
          className="inline-block animate-spin rounded-full border-4 border-solid border-primary-red border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          style={{ width: size, height: size }}
          role="status"
        >
          <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
            Loading...
          </span>
        </div>

        {/* 로딩 메시지 */}
        {message && (
          <p className="mt-4 text-gray-600 text-sm font-medium">{message}</p>
        )}
      </div>
    </div>
  );
}
